import * as i0 from '@angular/core';
import { Component, ViewChild, Input, NgModule } from '@angular/core';
import * as i3 from 'primeng/tooltip';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@pv-frontend/pv-shared-components/svg-icon';
import { SvgIconModule } from '@pv-frontend/pv-shared-components/svg-icon';

class CopyComponent {
    constructor() {
        this.showCopySuccessIcon = false;
        /**
         * To render the tooltip top | left | right | bottom positions
         */
        this.toolTipPosition = 'right';
        /**
         * One variant of tooltip where underline is shown below the label passed
         */
        this.label = '';
        /**
         * The value to be copied to the clipboard when the label/icon is clicked upon
         */
        this.valueToBeCopied = '';
        /**
         * The text to be shown in the tooltip when copy is successful
         */
        this.successText = 'Copied';
        /**
         * the default amount of time for which we will show the tooltip
         */
        this.delay = 800;
        /**
         * Icon to be used for copy
         */
        this.copyIcon = 'copy';
        /**
         * Icon to be used for copy
         */
        this.successIcon = 'tick';
        this.style = {};
        this.iconStyle = {
            fill: 'var(--primary-color)',
            height: '1rem',
            width: '1rem',
        };
    }
    isSecuredWindow() {
        return window.isSecureContext;
    }
    handleClick() {
        /**
         * Async clipboard isn't allowed in non-secure context
         * Reference - https://web.dev/async-clipboard/#security-and-permissions
         * Check if it is a secure context and then only proceed to write to clipboard
         */
        if (this.isSecuredWindow()) {
            navigator.clipboard
                .writeText(this.valueToBeCopied)
                .then(() => {
                this.showCopySuccessIcon = true;
                // tooltip becomes available in dom once the success icon svg is rendered
                // hence schedule it via timeout and not in main thread
                setTimeout(() => this.tooltip?.show());
                // now revert back to copy icon after the delay
                setTimeout(() => (this.showCopySuccessIcon = false), this.delay);
            })
                .catch((error) => {
                // todo - integrate with error service in future
                console.error('something went wrong while copying ', error);
            });
        }
        else {
            // todo - integrate with error service in future
            console.error('copy not allowed in insecure window, please use HTTPS');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: CopyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.8", type: CopyComponent, selector: "pv-copy", inputs: { toolTipPosition: "toolTipPosition", label: "label", valueToBeCopied: "valueToBeCopied", successText: "successText", delay: "delay", copyIcon: "copyIcon", successIcon: "successIcon", style: "style" }, viewQueries: [{ propertyName: "tooltip", first: true, predicate: Tooltip, descendants: true }], ngImport: i0, template: "<div\n  [style]=\"this.style?.container\"\n  class=\"pv-copy-container flex surface-text-muted-low-contrast\">\n  <p\n    *ngIf=\"this.label && !this.showCopySuccessIcon\"\n    [style]=\"this.style?.label\"\n    class=\"m-0 text-base underline cursor-pointer pv-dotted-decoration\"\n    (click)=\"this.handleClick()\">\n    {{ this.label }}\n  </p>\n\n  <pv-svg-icon\n    styleClass=\"cursor-pointer\"\n    [name]=\"this.copyIcon\"\n    *ngIf=\"!this.label && !this.showCopySuccessIcon\"\n    (click)=\"this.handleClick()\"\n    [style]=\"this.style?.copyIconStyle ?? this.iconStyle\"></pv-svg-icon>\n\n  <pv-svg-icon\n    styleClass=\"cursor-pointer\"\n    [name]=\"this.successIcon\"\n    *ngIf=\"this.showCopySuccessIcon\"\n    [pTooltip]=\"this.successText\"\n    tooltipEvent=\"focusout\"\n    [tooltipPosition]=\"toolTipPosition\"\n    [tooltipDisabled]=\"false\"\n    [style]=\"this.style?.successIconStyle ?? this.iconStyle\"></pv-svg-icon>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.SvgIconComponent, selector: "pv-svg-icon", inputs: ["name", "srcUrl", "style", "styleClass"] }, { kind: "directive", type: i3.Tooltip, selector: "[pTooltip]", inputs: ["tooltipPosition", "tooltipEvent", "appendTo", "positionStyle", "tooltipStyleClass", "tooltipZIndex", "escape", "showDelay", "hideDelay", "life", "positionTop", "positionLeft", "autoHide", "fitContent", "hideOnEscape", "pTooltip", "tooltipDisabled", "tooltipOptions"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: CopyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pv-copy', template: "<div\n  [style]=\"this.style?.container\"\n  class=\"pv-copy-container flex surface-text-muted-low-contrast\">\n  <p\n    *ngIf=\"this.label && !this.showCopySuccessIcon\"\n    [style]=\"this.style?.label\"\n    class=\"m-0 text-base underline cursor-pointer pv-dotted-decoration\"\n    (click)=\"this.handleClick()\">\n    {{ this.label }}\n  </p>\n\n  <pv-svg-icon\n    styleClass=\"cursor-pointer\"\n    [name]=\"this.copyIcon\"\n    *ngIf=\"!this.label && !this.showCopySuccessIcon\"\n    (click)=\"this.handleClick()\"\n    [style]=\"this.style?.copyIconStyle ?? this.iconStyle\"></pv-svg-icon>\n\n  <pv-svg-icon\n    styleClass=\"cursor-pointer\"\n    [name]=\"this.successIcon\"\n    *ngIf=\"this.showCopySuccessIcon\"\n    [pTooltip]=\"this.successText\"\n    tooltipEvent=\"focusout\"\n    [tooltipPosition]=\"toolTipPosition\"\n    [tooltipDisabled]=\"false\"\n    [style]=\"this.style?.successIconStyle ?? this.iconStyle\"></pv-svg-icon>\n</div>\n" }]
        }], propDecorators: { tooltip: [{
                type: ViewChild,
                args: [Tooltip]
            }], toolTipPosition: [{
                type: Input
            }], label: [{
                type: Input
            }], valueToBeCopied: [{
                type: Input
            }], successText: [{
                type: Input
            }], delay: [{
                type: Input
            }], copyIcon: [{
                type: Input
            }], successIcon: [{
                type: Input
            }], style: [{
                type: Input
            }] } });

class PvCopyModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvCopyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.8", ngImport: i0, type: PvCopyModule, declarations: [CopyComponent], imports: [CommonModule, SvgIconModule, TooltipModule], exports: [CopyComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvCopyModule, imports: [CommonModule, SvgIconModule, TooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvCopyModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SvgIconModule, TooltipModule],
                    exports: [CopyComponent],
                    declarations: [CopyComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CopyComponent, PvCopyModule };
